import styled from "@emotion/styled";
export const SectionRoot = styled.div`
  display: flex;
  align-items: center;
`;
